import React from "react";
import Fade from "react-reveal/Fade";
import PropTypes from "prop-types";

const QuestionsForDetailedPage = ({ data }) => {
  QuestionsForDetailedPage.propTypes = {
    data: PropTypes.object.isRequired, // Replace `object` with the correct type
  };
  return (
    <div className="pattern-bg2">
      <div className="faq-section  pattern-bg2">
        <Fade bottom>
          <div className="  mb-10 ">
            <div className="grid lg:gap-4">
              {data.map((item) => {
                return (
                  <div key={item}>
                    <details className="group border-l-4 border-[#281c54] bg-white px-[15px] py-[10px] [&_summary::-webkit-details-marker]:hidden mb-2 shadow-xl rounded-xl  single-faq">
                      <summary className="flex items-center justify-between cursor-pointer">
                        <h2 className="text-xl !font-bold  text-gray-900 heading-sub1">
                          {item.q}
                        </h2>
                        <span className="ml-1.5 flex-shrink-0 rounded-full  bg-opacity-[90%] p-1.5 text-white ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="flex-shrink-0 w-8 h-8 transition duration-300 group-open:-rotate-45 text-[32px] text-pent"
                            viewBox="0 0 20 20"
                            fill="#b99653"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </span>
                      </summary>
                      <p className="mt-[0.5rem] mb-[1rem] leading-relaxed text-gray-700 paragraph ">
                        {item.a}
                      </p>
                    </details>
                  </div>
                );
              })}
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default QuestionsForDetailedPage;
